import React from "react";
import cx from "classnames";
import ScheduleCalendarSkeleton from "../Skeleton/ScheduleCalendar.skeleton";
import styles from "../grid-sections.module.scss";
import { SkeletonBase } from "@foris/avocado-suite";

const GridSectionsSkeleton = () => {
  return (
    <div className={styles.gridInfo}>
      <div className={cx(styles.infoWeeks, styles.infoWeeks__skeleton)}>
        <SkeletonBase width={280} height={36} />

        <div className={styles.weekly}>
          <div className={styles.weekly_navigator}>
            <SkeletonBase width={150} height={16} />
            <SkeletonBase width={90} height={16} />
          </div>

          <div className={styles.weekly_weeks}>
            {[...Array(56)].map((_, index) => (
              <SkeletonBase key={`weekly-week-${index}`} width={28} height={28} />
            ))}
          </div>
        </div>
      </div>
      <div className={styles.sectionGrid}>
        <ScheduleCalendarSkeleton />
      </div>
    </div>
  );
};

export default GridSectionsSkeleton;
